import React from "react";
import {Col, Container, Row} from "reactstrap";
import FounderImage from "../../assets/RealEnglishImages/FounderImage.jpg";
import "./OurTeachers.css";
const OurTeachers = () => {
  return (
    <React.Fragment>
      <section
        className="section "
        id="OurTeachers"
      >
        <Container>
          <Row className="justify-content-center">
            <Col
              lg={10}
              className="pb-5 mb-5"
            >
              <div>
                <h2 className="fw-bold text-primary text-center pb-2">
                  Meet Our Teachers
                </h2>
                <p className=" lh-base">
                  At Real English Academy, we believe that great teaching comes
                  from passion, expertise, and continuous learning. Our teachers
                  are dedicated to making English a natural and enjoyable
                  experience for every student.
                </p>
              </div>
            </Col>
            <Col lg={10}>
              <div className="d-flex align-items-center founder-responsive ">
                <div className="me-5">
                  <img
                    src={FounderImage}
                    alt="Founder"
                    className="img-fluid  founder-image"
                    style={{
                      width: "1000px",
                      height: "300px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <div>
                  <h3 className="fw-bold text-success">About Our Founder</h3>
                  <p className="lh-base">
                    Our lead educator and founder brings a wealth of experience
                    and a deep love for teaching. With a degree from the English
                    School of the Aristotle University of Thessaloniki and
                    Erasmus studies in Ireland, she has gained international
                    insights into language learning.
                  </p>
                  <p className="lh-base">
                    Her commitment to innovative education is evident through
                    numerous specialized seminars, including extensive training
                    in teaching English to students with dyslexia. She has also
                    participated in a Teacher’s Retreat, working alongside two
                    of Greece’s most renowned English educators to refine
                    advanced teaching methodologies.
                  </p>
                  <p className="lh-base">
                    With a focus on interactive, immersive, and engaging
                    lessons, she ensures that every student at Real English
                    Academy learns English in a way that feels natural,
                    practical, and fun!
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default OurTeachers;
